import React, { Fragment } from 'react';
import mathjs from 'mathjs';

const getAnswerByWeight = (weight, question_progresses) =>
  question_progresses.find(({ question }) => question.weight === weight).answer;

const getFormulaAnswer = (question_progresses, formula) => {
  if (!formula) {
    return '';
  }

  const formulaWithValues = formula.replace(
    /#\d/gi,
    x =>
      `${getAnswerByWeight(parseInt(x.substring(1), 10), question_progresses)}`
  );

  const answer = formulaWithValues.includes('null')
    ? '—'
    : Math.round(mathjs.eval(formulaWithValues));

  return !isNaN(answer)
    ? answer
    : 'Please, provide the right values (number) in the previous questions';
};

const getTextTypePrompt = question_progresses => (
  <div>
    {question_progresses.map(
      (
        { answer, question: { additional_info, question_type, title } },
        index
      ) => {
        const description =
          question_type === 'formula'
            ? getFormulaAnswer(question_progresses, additional_info)
            : answer;
        return (
          <Fragment key={index}>
            <p className="mt-0">{title}</p>
            <p className="mt-0 ml-20">{description}</p>
          </Fragment>
        );
      }
    )}
  </div>
);

const getFixedInputValue = (id, content_progress) => {
  let value = '';
  content_progress.question_progresses.forEach(
    ({ question_answer_progresses }) =>
      question_answer_progresses.forEach(question_answer_progress => {
        if (question_answer_progress.question_answer_id === id) {
          value = question_answer_progress.value;
        }
      })
  );
  return value;
};

const getFixedInputPrompt = ({ content_progress, input_item }) => {
  const { questions } = input_item.content;
  return questions.map((question, index) => (
    <div key={index}>
      <h4 className="m-0 mb-5">{question.title}</h4>
      <div>
        {question.question_answers.map(({ id, title }) => {
          const value = getFixedInputValue(id, content_progress);
          return <p key={id} className="mt-0 ml-20">{`${title}: ${value}`}</p>;
        })}
      </div>
    </div>
  ));
};

const getPromptsNotes = journalPrompts => {
  const notesByModules = {};
  Object.keys(journalPrompts).forEach(module => {
    notesByModules[module] = [];
    journalPrompts[module].forEach(prompt => {
      const { id, question_progresses, question_set } = prompt.content_progress;
      const { question_set_type } = question_set;

      const content =
        question_set_type === 'text' || question_set_type === 'number'
          ? getTextTypePrompt(question_progresses)
          : getFixedInputPrompt(prompt);

      notesByModules[module].push({
        id,
        content,
        type: 'journalPrompt',
        title: question_set.title
      });
    });
  });
  return notesByModules;
};

export default getPromptsNotes;



// WEBPACK FOOTER //
// ./src/containers/Journal/utils/getPromptsNotes.js